import Road from './Road'
import color from './colorThemes'
import config from '../../../config'

const { minZoom, maxZoom } = config.map

export default {
  ...Road,
  id: 'roadPrimaryMotorway',
  filter: [...Road.filter, ['in', 'type', 'motorway', 'primary']],
  paint: {
    ...Road.paint,
    'line-color': {
      stops: [
        [minZoom, color.roadPrimaryStart],
        [maxZoom, color.roadPrimaryEnd],
      ],
    },
    'line-width': {
      base: 2,
      stops: [[minZoom, 4], [maxZoom, 30]],
    },
  },
}
